import React from "react";
import { Container, Row, Col } from 'react-grid-system'
// STYLES
import styled from "styled-components";
import Colors from "../../shared/colors";
import { lighten } from "polished";

// COMPONENTS
import Title from '../../components/title/title.component';
import SubTitle from '../../components/subtitle/subtitle.component';
import Modal from "react-responsive-modal";

// STYLES COMPONENTS
const Section = styled.section `
    padding-top: 120px;
    padding-bottom: 140px;

    @media screen and (max-width: 767px) {
        padding-top: 60px;
        padding-bottom: 80px;
    }
`
const AboutTitle = styled.h6 `
    color: ${Colors.primary};
    font-family: "PT Sans";
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
    text-transform: uppercase;
    margin-bottom: 0px;

    @media screen and (max-width: 767px) {
        text-align:center;
    }
`
const AboutText = styled.p `
    font-size: 16px;
    margin-top: 5px;
    color: hsl(0, 0%, 17%);
    font-family: "PT Sans";

    @media screen and (max-width: 767px) {
        text-align:center;
    }
`
const AboutTextInfo = styled.p `
    font-size: 16px;
    margin: 10px;
    margin-top:5px;
    color: hsl(0, 0%, 17%);
    font-family: "PT Sans";
    text-align: justify;
    @media screen and (max-width: 767px) {
        text-align:center;
    }
`
const Logo = styled.img `
    width: 140px;
    margin-top: 10px;
    align-self: center;
    transition: all 0.3s ease-in-out;
`

const Modalstyles = {
    modal:{
        marginTop:'10%',
    },
    closeIcon:{
        top: 5,
        right: 5,
    }
}

const CenterButton = styled.div `
    margin-left: auto;
    margin-right: auto;
    margin-top: 50px;
    margin-bottom: 40px;
`

const LinkButton = styled.div `
    background-color: ${Colors.primary};
    color: ${Colors.white};
    border-radius: 3px;
    padding: 15px 20px;
    cursor: pointer;
    text-decoration: none;
    transition: all 0.3s ease;
    font-family: "PT Sans";

    &:hover{
        background: ${lighten(0.05, Colors.primary)};
    }
`
export default class About extends React.PureComponent {
    constructor(props) {
        super(props);
        // Don't call this.setState() here!
        this.state = { 
            open: false,
            logo: '',
        };
        this.setLogo = this.setLogo.bind(this);
      }
      
      componentDidMount() {
        window.addEventListener("scroll", this.handleScroll);
        this.setLogo(this.props.i18n);
      }

      setLogo(i18n) {
        if (i18n.language === 'pt') {
                this.setState({logo: 'https://tasteportugal.com/static/media/pt_logo_color.d6c74677.svg'});
        } else {
                this.setState({logo: 'https://tasteportugal.com/static/media/en_logo_color.e5de8196.svg'});
        }
      }

      onOpenModal = () => {
        this.setState({ open: true });
      };
    
      onCloseModal = () => {
        this.setState({ open: false });
      };

    render () {
        let {t } = this.props;
        const { open } = this.state;

        return (
            <Section id="goToAbout">
                <Container>
                    <Row>
                        <Col sm={12} className="center">
                            <Title text={t('ENTRE SABORES, SABER FAZER, COMEMORAÇÕES, AROMAS, PAISAGENS E GENTES, MOSTRAMOS O MAIS PURO DE SER PORTUGUÊS')}/>
                            <SubTitle text={t('Percorremos vales e montanhas, praias e planícies, para apresentar numa única plataforma')} color={Colors.text.secondary} />
                        </Col>
                        <Col md={6} sm={12}>
                            <AboutTitle>{t('Rede de Restaurantes Portugueses no Mundo')}</AboutTitle>
                            <AboutText>{t('Estruturar e implementar a primeira fase da Rede de Restaurantes Portugueses no Mundo, enquanto nossos embaixadores gastronómicos espalhados pelos cinco continentes')}</AboutText>
                        </Col>
                        <Col md={6} sm={12}>
                            <AboutTitle>{t('Eventos e ações')}</AboutTitle>
                            <AboutText>{t('Divulgar a nossa participação em eventos internacionais de referência turística e gastronómica e promover as ações de suporte à constituição da Rede de Restaurantes Portugueses no Mundo que se realizam em cada um dos países')}</AboutText>
                        </Col>
                        <Col md={6} sm={12}>
                            <AboutTitle>{t('Produtos endógenos portugueses')}</AboutTitle>
                            <AboutText>{t('Um catálogo de produtos regionais, qualificados e/ou de interesse gastronómico')}</AboutText>
                        </Col>
                        <Col md={6} sm={12}>
                            <AboutTitle>{t('Receituário')}</AboutTitle>
                            <AboutText>{t('Um conjunto de receitas regionais possíveis de serem executadas em cada um dos países onde se vai desenvolver a Rede de Restaurantes Portugueses no Mundo')}</AboutText>
                        </Col>
                          <CenterButton><LinkButton onClick={this.onOpenModal}>{t('Origem da Marca')}</LinkButton></CenterButton>
                            <Modal  styles={Modalstyles} showCloseIcon={true} open={open} onClose={this.onCloseModal.bind(this)} center>
                               <Row>
                                  <Col sm={12} className="center">
                                    <Logo src={this.state.logo}/>
                                    </Col> 
                                  </Row>
                                  <Row>
                                      <Col sm={12} className="center">
                                          <Title text={t('Origem da Marca')}/>
                                      </Col>
                                      <Col sm={12}>
                                          <AboutTextInfo>
                                              O Programa PROVE/TASTE Portugal foi desenvolvido em 2010 pelo Turismo de Portugal, IP, com o objetivo de levar a cabo a divulgação da excelência do património culinário nacional, construindo para Portugal uma identidade gastronómica reconhecida e reconhecível.
                                          </AboutTextInfo>
                                          <AboutTextInfo>
                                              A primeira vez que o produto Gastronomia e Vinhos foi identificado como estratégico para o Turismo em Portugal, foi em 2007, no Plano Estratégico para o Turismo (PENT) e assim, a criação do Programa PROVE/TASTE Portugal em 2010, pretendia aumentar a visibilidade, reconhecimento e a perceção, nacional e internacional, de uma gastronomia de excelência, sustentada em produtos de gastronomia genuínos de grande qualidade, através da realização de conjunto diversificado de iniciativas, tudo sob a umbrela das marcas PROVE Portugal (para ações realizadas em território nacional) e TASTE Portugal (para ações realizadas em território estrangeiro).
                                          </AboutTextInfo>
                                          <AboutTextInfo> 
                                              Foram estas marcas que foram cedidas à AHRESP, pelo Turismo de Portugal, IP em 2017, para que possam dar seguimento aos desígnios iniciais, para que foram criadas.
                                          </AboutTextInfo>
                                      </Col>
                                  </Row>
                            </Modal>
                    </Row>
                </Container>
            </Section>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/about/about.component.js